module.exports = __webpack_public_path__ + "6e445a6743da35f25b0e7edc80931346.svg";